export default [
    { name: "Social", color: "#795548" },
    { name: "Home", color: "#1B5E20" },
    { name: "Work", color: "#4A148C" }
    , { name: "Sport", color: "#880E4F" }
]


export const colorMap = {
    "Social": "#795548",
    "Home": "#1B5E20",
    "Work": "#4A148C",
    "Sport": "#880E4F"
}